import { useState } from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import type {
  GroupBase,
  Props as SelectProps,
} from 'react-select';

import { SelectFetch } from 'react-select-fetch';

import type { ComponentProps } from 'react-select-async-paginate';
import type {
  UseSelectFetchParams,
} from 'react-select-fetch';

import { FilterSelectBase } from '../FilterSelectBase';

import { selectComponentsAsync } from '../ReactSelectExtended/filterComponents';
import type {
  OptionTypeBase,
  FilterSelectBaseProps,
} from '../ReactSelectExtended/types';

type SelectWithInputValueProps<
OptionType extends OptionTypeBase,
Group extends GroupBase<OptionType>,
IsMulti extends boolean,
> =
  & SelectProps<OptionType, IsMulti, Group>
  & UseSelectFetchParams<OptionType, Group>
  & ComponentProps<OptionType, Group, IsMulti>;

function SelectWithInputValue<
OptionType extends OptionTypeBase,
Group extends GroupBase<OptionType>,
IsMulti extends boolean,
>(
  props: SelectWithInputValueProps<OptionType, Group, IsMulti>,
): ReactElement {
  const [inputValue, setInputValue] = useState('');

  return (
    <SelectFetch
      {...props}
      inputValue={inputValue}
      onInputChange={setInputValue}
    />
  );
}

export type FilterSelectAjaxProps<
OptionType extends OptionTypeBase,
Group extends GroupBase<OptionType>,
IsMulti extends boolean,
> =
  & Omit<FilterSelectBaseProps<OptionType, IsMulti, Group>, 'renderSelect'>
  & UseSelectFetchParams<OptionType, Group>
  & ComponentProps<OptionType, Group, IsMulti>;

export function FilterSelectAjax<
OptionType extends OptionTypeBase,
Group extends GroupBase<OptionType>,
IsMulti extends boolean,
>(
  props: FilterSelectAjaxProps<OptionType, Group, IsMulti>,
): ReactElement {
  return (
    <FilterSelectBase
      {...props}
      renderSelect={(selectRenderProps): ReactNode => (
        <SelectWithInputValue
          {...props}
          defaultOptions
          {...selectRenderProps}
          components={selectComponentsAsync}
        />
      )}
    />
  );
}

FilterSelectAjax.defaultProps = {
  queryParams: {},
  searchParamName: 'q',
  pageParamName: 'page',
  offsetParamName: null,
  mapResponse: undefined,
  get: undefined,
  value: null,
  isDisabled: false,
  mainPlaceholder: 'Выберите...',
  getOptionLabel: undefined,
  labelKey: 'label',
  getOptionValue: undefined,
  valueKey: 'value',
  onChange: (): void => {},
};
